// 瓜田周刊 · 八卦内容数据
// 说明：本文件为静态展示数据，栏目视角偏"盘点/造型/幕后/舞台"等聚合话题，不做针对具体真人的不实报道。

export const site = {
  brand: '瓜田周刊',
  slogan: '吃瓜不迷路，八卦一网打尽',
  tagline: '把明星八卦合集、长图、深扒与盘点，整理成一杯好读的下午茶。',
  email: 'editor@guatian.example',
};

export type CatKey = 'quick' | 'deep' | 'round' | 'redcarpet' | 'behind';

export const catMeta: Record<CatKey, string> = {
  quick: '八卦速递',
  deep: '硬核深扒',
  round: '明星盘点',
  redcarpet: '红毯造型',
  behind: '幕后现场',
};

export const filters: { key: 'all' | CatKey; label: string }[] = [
  { key: 'all', label: '全部图文' },
  { key: 'quick', label: '八卦速递' },
  { key: 'deep', label: '硬核深扒' },
  { key: 'round', label: '明星盘点' },
  { key: 'redcarpet', label: '红毯造型' },
  { key: 'behind', label: '幕后现场' },
];

export interface FeedItem {
  id: number;
  cat: CatKey;
  title: string;
  excerpt: string;
  time: string;
  heat: number;
  img: string;
  alt: string;
  body: string[];
}

export const feedItems: FeedItem[] = [
  {
    id: 1,
    cat: 'deep',
    title: '一部戏能多较真？从服化道细节看主创团队的轴劲儿',
    excerpt: '当剧组为了一个镜头把整座城都等亮，这种“较真”正在悄悄改变观众对品质的判断标准。',
    time: '今天 09:20',
    heat: 986,
    img: 'https://readdy.ai/api/search-image?query=dramatic%20costume%20wardrobe%20rack%20inside%20a%20film%20studio%20with%20hanging%20elegant%20traditional%20and%20modern%20gowns%2C%20warm%20golden%20practical%20lighting%2C%20shallow%20depth%20of%20field%2C%20editorial%20behind%20the%20scenes%20photography%2C%20warm%20cream%20and%20coral%20color%20palette%2C%20cinematic%20and%20rich%20in%20detail&width=600&height=750&seq=gossip-feed-01&orientation=portrait',
    alt: '剧组服化道衣架与华丽戏服，暖色编辑部幕后影像',
    body: [
      '道具组总爱说一句话：观众看不见的细节，才是戏的底色。为了还原一场旧时代的戏，主创们会把每一颗纽扣的材质翻出来较真，连裙摆压出的褶皱弧度都要对着老照片反复比对。',
      '服化道不是摆设，它是帮角色说话的第一套“台词”。从景片做旧的火候，到餐桌上瓷器的花纹年代，考据团队常在片场红着眼眶坚持改到最后一版，只因“错一个细节，观众就出戏了”。',
      '越来越多的观众开始把注意力从剧情弹幕移到画面细节上，甚至有人专门二刷三刷去“找茬”。这种较真的剧组，正用看得见的诚意，重新定义什么叫高质量制作。',
    ],
  },
  {
    id: 2,
    cat: 'quick',
    title: '新综艺阵容官宣，首期录制路透释出，观众已经开始磕上了',
    excerpt: '一档综艺能否大火，往往从阵容揭晓的那一刻就有了苗头，而这一届的嘉宾化学反应意外地好磕。',
    time: '今天 08:05',
    heat: 1240,
    img: 'https://readdy.ai/api/search-image?query=vibrant%20variety%20show%20stage%20with%20neon%20ring%20lights%20and%20studio%20audience%20silhouettes%20seen%20from%20afar%2C%20backstage%20hustle%2C%20warm%20amber%20and%20coral%20glow%2C%20editorial%20entertainment%20photography%2C%20dynamic%20energetic%20composition&width=600&height=750&seq=gossip-feed-02&orientation=portrait',
    alt: '综艺节目舞台灯光与观众剪影，暖色氛围',
    body: [
      '阵容刚官宣，社交平台就炸了锅。节目组这回收起了一贯的神秘感，直接放出首期录制的一组路透，镜头里几个性格迥异的嘉宾凑在一起，气场意外地互补。',
      '从路透能看出，这档节目把“化学反应”当成了重点。无论是分组游戏里的你来我往，还是围坐闲聊时的接梗默契，观众隔着屏幕都忍不住截图嗑糖，直呼“这组合选得妙”。',
      '一档综艺能不能火，嘉宾合不合拍往往决定了上限。目前来看，这个阵容的开局让人期待值拉满，接下来就看剪辑和赛制能不能接住这波热度了。',
    ],
  },
  {
    id: 3,
    cat: 'redcarpet',
    title: '颁奖礼红毯盘点：大胆撞色与经典黑裙同场竞技',
    excerpt: '红毯从不缺惊喜，这一晚有人把高饱和色穿成了高光，也有人把极简黑裙穿出了满满的故事感。',
    time: '昨天 22:40',
    heat: 1530,
    img: 'https://readdy.ai/api/search-image?query=elegant%20person%20on%20a%20red%20carpet%20seen%20from%20behind%20wearing%20a%20flowing%20statement%20gown%2C%20glowing%20gala%20lights%20and%20bokeh%20crowd%20ahead%2C%20warm%20editorial%20fashion%20photography%2C%20sophisticated%20composition%2C%20cream%20and%20coral%20palette%2C%20face%20not%20visible&width=600&height=750&seq=gossip-feed-03&orientation=portrait',
    alt: '红毯上裙摆飞扬的背影造型，暖色时尚摄影',
    body: [
      '这一晚的红毯成了色彩的试验场。有人把大胆的高饱和撞色穿上身，在镁光灯下格外抢镜；也有人以退为进，用一条极简黑裙撑起了全场最有质感的一格画面。',
      '造型师的功课永远做在细节里：腰线的高低、裙摆的垂坠、配饰的体量，每一处都在悄悄决定镜头前的比例与气场。与其堆砌元素，不如让一件单品替你说话。',
      '红毯之外的讨论同样热烈，网友对每个造型的解析比设计师本人都认真。从面料到剪裁，从鞋跟到指甲油，一场红毯下来，诞生的不止是美照，更是整晚的谈资。',
    ],
  },
  {
    id: 4,
    cat: 'round',
    title: '2026上半年最出圈的舞台，你为哪一场尖叫过',
    excerpt: '一场好的表演能让人反复回看，这份盘点收录了上半年让评论区集体失语的舞台名场面。',
    time: '昨天 19:15',
    heat: 1710,
    img: 'https://readdy.ai/api/search-image?query=dramatic%20concert%20stage%20with%20confetti%20falling%20and%20dancer%20silhouettes%20leaping%20in%20the%20air%2C%20spotlights%20in%20warm%20gold%20and%20coral%2C%20energetic%20editorial%20performance%20photography%2C%20strong%20sense%20of%20motion&width=600&height=750&seq=gossip-feed-04&orientation=portrait',
    alt: '舞台上舞者跃起与彩带纷飞的动感瞬间',
    body: [
      '盘点上半年的舞台，绕不开那些让人“当场起鸡皮疙瘩”的名场面。有的靠一段突破边界的编舞封神，有的则用一句恰到好处的高音让全场屏息。',
      '一场神级舞台的诞生，是选曲、编舞、灯光与运镜协同发力的结果。看似随性的一跃，背后是无数次彩排打磨出的肌肉记忆；那一秒的爆发，是整支团队反复较真的答案。',
      '评论区里，观众纷纷晒出自己心中的Top 3。好表演的魅力正在于此——它让素不相识的人在同一段旋律里拥有共同的尖叫，也让大家心甘情愿为它反反复复地按下回放。',
    ],
  },
  {
    id: 5,
    cat: 'behind',
    title: '深夜收工的剧组：凌晨三点的盒饭与一场片场烟花',
    excerpt: '聚光灯熄灭之后，片场的另一种热闹才刚刚开始，那些不为人知的凌晨，藏着最真实的幕后温度。',
    time: '昨天 16:30',
    heat: 842,
    img: 'https://readdy.ai/api/search-image?query=film%20crew%20packing%20up%20late%20at%20night%2C%20warm%20practical%20lamps%2C%20catering%20boxes%20on%20a%20table%2C%20a%20film%20camera%20silhouette%2C%20cinematic%20warm%20documentary%20editorial%20style%2C%20cozy%20and%20human&width=600&height=750&seq=gossip-feed-05&orientation=portrait',
    alt: '深夜片场收工的剧组与工作灯，纪实暖调',
    body: [
      '当城市陷入沉睡，片场却迎来一天中最紧张的冲刺。为了一场戏，灯光组要把几百盏灯一点点调准，场务抱着对讲机来回小跑，主创们围在监视器前反复核对最后一版。',
      '凌晨三点的盒饭总是温着的。导演喊“收工”的瞬间，有人瘫在椅子上，有人还在核对明天的通告。这时不知谁点燃了一场戏的烟花道具，短暂的绚烂里，所有人都笑了。',
      '聚光灯照不到的幕后，没有光鲜，只有一趟趟反复与一夜夜坚持。那些被剪进正片的光彩，背后是无数个这样的凌晨。这份温度，值得被看见。',
    ],
  },
  {
    id: 6,
    cat: 'quick',
    title: '平台年度片单官宣，口碑与流量的掰手腕又开始了',
    excerpt: '一份片单就是一份赌注，题材百花齐放背后，是平台对“叫好又叫座”这件事的持续较劲。',
    time: '昨天 11:10',
    heat: 1105,
    img: 'https://readdy.ai/api/search-image?query=cinema%20marquee%20with%20a%20stack%20of%20movie%20posters%20and%20film%20reels%20arranged%20on%20a%20designer%20desk%2C%20warm%20ambient%20lighting%2C%20editorial%20film%20marketing%20flat%20lay%2C%20cream%20and%20coral%20accents%2C%20detailed&width=600&height=750&seq=gossip-feed-06&orientation=portrait',
    alt: '桌面上的片单海报与胶片元素，编辑部平铺摄影',
    body: [
      '年度片单一出，立刻成了讨论的焦点。有人为心仪的题材被列入而欢呼，也有人担心爆款之后又是一地同质化的跟风之作。',
      '仔细观察这份片单，能看出平台明显在“口碑”与“流量”之间寻找新的平衡点。既有能撬动话题的大体量项目，也有敢于押注新导演、新视角的诚意之作，题材百花齐放。',
      '片单发布只是第一步，真正的胜负手在于成片质量。观众已经越来越难被简单的阵容和噱头打动，谁能把故事讲好，谁才能在这场掰手腕里笑到最后。',
    ],
  },
  {
    id: 7,
    cat: 'deep',
    title: '一部“爆款”是怎样炼成的：选角、服化与宣发的三重博弈',
    excerpt: '爆款从来不是单点运气，而是一场贯穿立项到播出、环环相扣的精密博弈。',
    time: '昨天 09:45',
    heat: 1330,
    img: 'https://readdy.ai/api/search-image?query=film%20directors%20editing%20suite%20with%20color%20grading%20monitors%20glowing%20warm%2C%20script%20pages%20and%20casting%20photos%20scattered%20on%20the%20desk%2C%20moody%20editorial%20behind%20the%20scenes%2C%20warm%20tones&width=600&height=750&seq=gossip-feed-07&orientation=portrait',
    alt: '剪辑室监视器与散落的剧本选角资料，暖调幕后',
    body: [
      '很多人以为爆款是撞大运，其实它更像一场精密策划后的偶然。选角环节，团队要在“流量号召力”和“角色契合度”之间反复掂量，宁可多面谈几十人也不轻易定下。',
      '服化道团队则在视觉上埋下记忆点，让角色一出场就自带辨识度；宣发侧又要在开播前恰到好处地释放物料，把期待值调校到既不过热也不冷淡的最佳区间。',
      '三重博弈环环相扣，任何一环掉链子都可能让前功尽弃。所谓爆款，不过是每一个环节都恰好做对了、又恰好被观众接住了的那一次全力以赴。',
    ],
  },
  {
    id: 8,
    cat: 'redcarpet',
    title: '电影节开幕夜：一抹高饱和绿凭什么抢走全场镜头',
    excerpt: '在满屏的经典配色里，敢于穿上一抹大胆的绿色，需要的不仅是勇气，更是对剪裁与气场的十足把握。',
    time: '前天 23:05',
    heat: 980,
    img: 'https://readdy.ai/api/search-image?query=person%20in%20a%20vivid%20green%20evening%20gown%20on%20an%20event%20staircase%20seen%20from%20behind%2C%20marble%20venue%20with%20warm%20chandelier%20light%2C%20editorial%20fashion%20photography%2C%20high%20color%20contrast%2C%20face%20not%20visible&width=600&height=750&seq=gossip-feed-08&orientation=portrait',
    alt: '身着高饱和绿礼服踏上大理石台阶的背影造型',
    body: [
      '电影节开幕夜群星汇聚，配色却出奇地“内卷”。在满屏的安全色里，一抹干净利落的高饱和绿格外醒目，把整条红毯的注意力都拽了过来。',
      '敢穿高饱和色的关键在于分寸感。真正的赢面不在颜色本身，而在剪裁是否利落、比例是否恰好、气场能否压得住——颜色只是放大镜，气质才是底色。',
      '开幕夜之后，这身造型迅速成为网友的截图素材库。事实证明，与其在人群中小心翼翼，不如用一次有态度的选择，把属于自己的一格画面稳稳占住。',
    ],
  },
  {
    id: 9,
    cat: 'round',
    title: '上半年口碑综艺大赏：治愈系为什么总能跑赢',
    excerpt: '当节奏越来越快，愿意慢下来的治愈系综艺反而成了观众心里的安全区，这份盘点聊聊它们赢在哪。',
    time: '前天 20:25',
    heat: 1210,
    img: 'https://readdy.ai/api/search-image?query=cozy%20reality%20show%20set%20with%20soft%20pastel%20decor%20and%20warm%20afternoon%20light%20streaming%20in%2C%20green%20plants%20and%20lounge%20chairs%2C%20calm%20editorial%20interior%20photography%2C%20gentle%20warm%20cream%20palette&width=600&height=750&seq=gossip-feed-09&orientation=portrait',
    alt: '治愈系综艺录影棚暖阳洒落的休息区布景',
    body: [
      '盘点上半年的口碑综艺，治愈系几乎场场不落。它们没有高强度的赛制和密集的冲突，反而用一间小院、一餐饭、一次慢声细语的谈心，稳稳接住了观众紧绷的神经。',
      '治愈系的赢面在于“陪伴感”。当观众在快节奏的生活里被消耗，一档愿意慢下来、认真吃饭好好说话的节目，就成了难得的情绪出口，让人看着看着就松弛下来。',
      '当然，治愈不等于无趣。真正跑赢的节目，往往在松弛里藏着编剧与嘉宾共创的巧思，让每一期都有记忆点，而不是沦为无意义的流水账，这也是口碑能持续发酵的关键。',
    ],
  },
];

export interface HeroStory {
  kicker: string;
  title: string;
  desc: string;
  time: string;
  img: string;
  alt: string;
}

export const heroStory: HeroStory = {
  kicker: '今日头条 · 八卦长图全收录',
  title: '明星八卦合集精选：一整晚的热搜，帮你整理成三分钟读完的长图',
  desc: '从红毯到片场，从速递到大瓜深扒，我们把散落在各处的八卦热讯重新排版成一页页能看懂、能分享的图文长图，吃瓜群众不用再四处蹲点，热门事件一网打尽。',
  time: '今天 · 滚动更新中',
  img: 'https://readdy.ai/api/search-image?query=wide%20editorial%20entertainment%20newsroom%20collage%2C%20warm%20cream%20backdrop%2C%20coral%20red%20and%20gold%20magazine%20masthead%20tiles%2C%20dramatic%20stage%20spotlight%2C%20stylish%20press%20aesthetic%2C%20sophisticated%20and%20layered&width=1280&height=720&seq=gossip-hero-01&orientation=landscape',
  alt: '编辑部风格的娱乐八卦新闻长图拼贴',
};

export interface LongItem {
  id: number;
  title: string;
  tag: string;
  count: number;
  img: string;
  alt: string;
}

export const longItems: LongItem[] = [
  {
    id: 1,
    title: '上半年颁奖礼红毯长图合集：从入场到领奖的一百种表情',
    tag: '长图合集',
    count: 120,
    img: 'https://readdy.ai/api/search-image?query=vertical%20editorial%20collage%20of%20elegant%20red%20carpet%20moments%20seen%20from%20behind%2C%20warm%20film%20grain%2C%20magazine%20grid%20layout%2C%20coral%20and%20cream%20tones%2C%20cinematic&width=640&height=960&seq=gossip-long-01&orientation=portrait',
    alt: '红毯长图合集竖版拼贴',
  },
  {
    id: 2,
    title: '片场深夜日记：一组长图看尽剧组收工前的两个小时',
    tag: '长图合集',
    count: 96,
    img: 'https://readdy.ai/api/search-image?query=vertical%20documentary%20photo%20essay%20of%20a%20film%20set%20late%20at%20night%2C%20warm%20practical%20lights%2C%20crew%20silhouettes%2C%20storyboard%20style%20long%20image%2C%20cinematic%20warm%20tone&width=640&height=960&seq=gossip-long-02&orientation=portrait',
    alt: '片场深夜长图纪实拼贴',
  },
  {
    id: 3,
    title: '那些年我们追过的综艺名场面，做成一份长图慢慢回看',
    tag: '长图合集',
    count: 150,
    img: 'https://readdy.ai/api/search-image?query=vertical%20filmstrip%20collage%20of%20stage%20performance%20moments%20with%20warm%20gold%20spotlights%2C%20memories%20magazine%20style%2C%20nostalgic%20warm%20cream%20and%20coral%20tones&width=640&height=960&seq=gossip-long-03&orientation=portrait',
    alt: '综艺名场面回看长图拼贴',
  },
  {
    id: 4,
    title: '颁奖台上的高光时刻：值得二刷再二刷的动人发言合集',
    tag: '长图合集',
    count: 88,
    img: 'https://readdy.ai/api/search-image?query=vertical%20collage%20of%20an%20elegant%20awards%20stage%20with%20warm%20spotlights%20and%20golden%20statue%2C%20trophy%20close%20up%2C%20editorial%20long%20image%2C%20cream%20and%20gold%20palette%2C%20sophisticated&width=640&height=960&seq=gossip-long-04&orientation=portrait',
    alt: '颁奖高光时刻长图拼贴',
  },
  {
    id: 5,
    title: '从机场到剧组：明星日常穿搭长图精选，随手一拍也是大片',
    tag: '长图合集',
    count: 132,
    img: 'https://readdy.ai/api/search-image?query=vertical%20street%20style%20collage%20of%20effortless%20airport%20and%20on%20set%20looks%20seen%20from%20behind%2C%20warm%20natural%20light%2C%20editorial%20long%20image%2C%20cream%20coral%20and%20neutral%20tones&width=640&height=960&seq=gossip-long-05&orientation=portrait',
    alt: '明星日常穿搭长图拼贴',
  },
];

export interface RankItem {
  id: number;
  title: string;
  hot: string;
}

export const rankItems: RankItem[] = [
  { id: 1, title: '新一季选秀导师阵容引热议，观众期待值持续走高', hot: '爆' },
  { id: 2, title: '年度口碑剧集中段口碑逆转，细节党疯狂找彩蛋', hot: '热' },
  { id: 3, title: '综艺里一句话治好精神内耗，全网刷屏求解出处', hot: '热' },
  { id: 4, title: '红毯造型大乱斗，高饱和色成这届的最大赢家', hot: '热' },
  { id: 5, title: '幕后纪录上线：一部爆款的拍摄到底有多硬核', hot: '热' },
  { id: 6, title: '片单发布后网友吵翻天，你押谁口碑流量双丰收', hot: '新' },
  { id: 7, title: '老牌综艺焕新回归，怀旧与新鲜感如何两全', hot: '新' },
  { id: 8, title: '颁奖礼上那段最真诚的感言，被网友做成台词墙', hot: '新' },
];

export interface TabloidItem {
  id: number;
  title: string;
  time: string;
  tag: string;
}

export const tabloidItems: TabloidItem[] = [
  { id: 1, title: '红毯意外小插曲：裙摆被踩到的一瞬间，明星高情商化解', time: '09:40', tag: '小报精选' },
  { id: 2, title: '录影棚里一只突然入镜的猫，成了全场最大的“咖”', time: '08:50', tag: '小报精选' },
  { id: 3, title: '剧组盒饭测评走红，网友：这波真的把我看馋了', time: '昨天', tag: '小报精选' },
  { id: 4, title: '机场偶遇路透：素颜也扛打的秘诀是好好睡觉', time: '昨天', tag: '小报精选' },
  { id: 5, title: '后台互怼名场面：笑翻全场的“塑料姐妹”式拌嘴', time: '前天', tag: '小报精选' },
  { id: 6, title: '综艺里被剪掉的遗憾瞬间，粉丝扒出后集体意难平', time: '前天', tag: '小报精选' },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: '瓜田周刊的明星八卦内容从哪里来？',
    a: '我们由一支专注娱乐资讯的编辑部，从公开的活动通稿、剧组物料、综艺与颁奖礼素材中整理汇编，再以"合集、长图、深扒、盘点"的形式重新编排，帮助大家用最短时间看懂一整天的娱乐热点。',
  },
  {
    q: '什么是“八卦长图合集”？和普通新闻有什么区别？',
    a: '八卦长图合集是把某个话题下分散的图文，按时间线或逻辑整理成一页可长按保存、便于分享的长图内容。相比零散的实时快讯，它更像一份做完功课的“图文档案”，读完一遍就能掌握来龙去脉。',
  },
  {
    q: '深扒栏目会不会涉及不实或侵权的信息？',
    a: '深扒栏目坚持基于公开可查的素材做分析与整理，避免无依据的主观臆测，也不会泄露个人隐私。若内容引用到外部来源，我们会标明出处，并欢迎通过投稿邮箱反馈任何需要更正或删除的信息。',
  },
  {
    q: '多久更新一次？如何不错过热门八卦盘点？',
    a: '速递类内容每日上午与晚间各滚动更新一轮，深扒与盘点栏目每周固定更新。你可以在页尾订阅我们的八卦速报，每期热点上线时会第一时间推送到你的邮箱，热门事件一网打尽不迷路。',
  },
  {
    q: '可以投稿或提供报料线索吗？',
    a: '非常欢迎。如果你有值得整理的八卦合集、深扒选题或独家路透素材，可以填写页尾的投稿/报料表单，编辑部会尽快评估并回复。请确保素材真实、来源清晰，非公开来源的内容恕难采用。',
  },
];